import RepositoryFactory from "../../admin/apis/index";
const dns = RepositoryFactory.dnsRecord;

export default {
  addDomain({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await dns.addDomain(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getDNSRecord({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await dns.getDNSRecord(payload);
        console.log(data, "data record");
        commit("DNS_RECORD", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  scanDNS({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await dns.scanDNS(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  checkData({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await dns.checkData(payload);
        console.log(data, "khhjhbj");
        commit("DNS_RECORD", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
